import {css} from "lit";
import {commonStyles} from "./styles/Common.js";
import {iconStyles} from "./styles/Icons.js";

export const tooltipStyles = [commonStyles, iconStyles, css`
	:host {
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
		z-index: 2147483627;
	}

	.tooltip-floating {
		width: max-content;
		max-width: min(85vw, 400px);
		background: var(--pn-tooltip-bg);
		color: var(--pn-tooltip-color);
		padding: 8px 10px;
		font-size: var(--pn-font-size-base);
		line-height: 1.4;
		white-space: pre-line;
		overflow-wrap: break-word;
		z-index: 1;
		pointer-events: none;
		user-select: none;

		animation-name: fadeIn;
		animation-duration: 0.5s;
		/* From pn-browser-ext tippy tooltip styles */
		animation-timing-function: cubic-bezier(.54,1.5,.38,1.11);
	}

	a {
		/* Better color contrast on black tooltip background */
		color: var(--pn-color-link);
	}

	.tooltip-nowrap {
		white-space: nowrap;
	}

	.tooltip-arrow {
		position: absolute;
		background: var(--pn-tooltip-arrow-color);
		width: 10px;
		height: 10px;
		transform: rotate(45deg);
	}

	@keyframes fadeIn {
		from { opacity: 0; }
		to { opacity: 1; }
	}
`];
